import React from "react";
import Image from "next/image";
import Link from "next/link";
import { BASE_ASSETS_URL } from "@constants/constants";

const Certifications = ({
  certifications,
  displayText = true,
  customStyling = "gap-4",
  redirection = true,
}) => {
  return (
    <div className={`flex flex-wrap justify-center ${customStyling}`}>
      {certifications.map((certification, index) => (
        <Link
          href={`https://security.boloforms.com/`}
          target="_blank"
          key={index}
          className={`flex flex-col gap-2 justify-end items-center flex-wrap ${
            !redirection ? "pointer-events-none" : ""
          }`}
        >
          <Image
            src={`${BASE_ASSETS_URL}/v2/security/${certification.image}`}
            className="h-12 w-auto rounded-full"
            width={20}
            height={20}
            loading="lazy"
            alt={certification.name}
          />
          {displayText && (
            <p className="text-xs font-medium text-gray-800">
              {certification.name}
            </p>
          )}
        </Link>
      ))}
    </div>
  );
};

export default Certifications;
